module.exports = __webpack_public_path__ + "img/LogoLoading_circle01.dad99c14.png";